module.exports = __webpack_public_path__ + "static/fiamma-dc43741db2bc62105dae76fa0d03b4a2.jpg";